import { CitizenshipStatus } from '@zorro/clients';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { citizenshipStatusLabelConfig } from '@zorro/types';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, FieldValues, Path } from 'react-hook-form';

const citizenshipStatusOptions = Object.values(CitizenshipStatus).map(
  (status) => ({
    label: citizenshipStatusLabelConfig[status],
    value: status,
  })
);

type Props<T extends FieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & {
  selectProps?: SelectProps;
};

export const CitizenshipStatusInput = forwardRef(
  <T extends FieldValues, U extends Path<T>>(
    { selectProps, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => (
    <Select
      {...field}
      {...selectProps}
      ref={ref}
      label="Citizenship status"
      placeholder="Select citizenship status"
      data={citizenshipStatusOptions}
      size="lg"
    />
  )
);

CitizenshipStatusInput.displayName = 'CitizenshipStatusInput';
